import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { JsonPipe, NgIf } from "@angular/common";

@Component({
  selector: 'image-slider',
  standalone: true,
  imports: [
    JsonPipe,
    NgIf
  ],
  templateUrl: './image-slider.component.html'
})
export class ImageSliderComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() images: Array<{ url: string, contentType: string }> = [];
  @Input() animationSpeed = 500;
  @Input() autoPlaySpeed = 3000;
  @Input() aspectClass: string = '1/1';

  public currentSlide = 0;
  public hidden = false;

  private interval: any;

  ngOnInit() {

    this.interval = setInterval(() => {
      this.next();
    }, this.autoPlaySpeed);

  }

  ngAfterViewInit() {
    // console.log(this.aspectClass);
    console.log(this.images);
    for(let i of this.images) {
      if(i.contentType === "image/jpeg") {
        let img = new Image();
        img.onerror = () => {
          i.url = '/assets/images/blank.png';
        }
        img.src = i.url;
      }
    }
  }

  next() {
    let currentSlide = (this.currentSlide + 1) % this.images.length;
    this.jumpToSlide(currentSlide);
  }

  jumpToSlide(index: number) {
    this.hidden = true;
    setTimeout(() => {
      this.currentSlide = index;
      this.hidden = false;
    }, this.animationSpeed);
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
